module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avaliacao-wrapper"
  }, [_c('avaliacao-header', {
    attrs: {
      "pessoa": _vm.avaliacao.pessoa
    }
  }), _vm._v(" "), (_vm.etapa) ? _c('div', {
    staticClass: "avaliacao-content"
  }, [(_vm.etapa === 'termo-aceite') ? _c('avaliacao-termo-aceite', {
    attrs: {
      "etapa": _vm.etapa
    },
    on: {
      "update:etapa": function($event) {
        _vm.etapa = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.etapa === 'tema') ? _c('avaliacao-tema', {
    attrs: {
      "avaliacao": _vm.avaliacao,
      "etapa": _vm.etapa
    },
    on: {
      "update:avaliacao": function($event) {
        _vm.avaliacao = $event
      },
      "update:etapa": function($event) {
        _vm.etapa = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.etapa === 'redacao') ? _c('avaliacao-redacao', {
    attrs: {
      "avaliacao": _vm.avaliacao,
      "etapa": _vm.etapa,
      "is-loading": _vm.isLoading
    },
    on: {
      "update:avaliacao": function($event) {
        _vm.avaliacao = $event
      },
      "update:etapa": function($event) {
        _vm.etapa = $event
      },
      "update:isLoading": function($event) {
        _vm.isLoading = $event
      },
      "update:is-loading": function($event) {
        _vm.isLoading = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.etapa === 'confirmacao') ? _c('avaliacao-confirmacao') : _vm._e(), _vm._v(" "), (_vm.etapa === 'erro') ? _c('avaliacao-erro') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('app-content-loader', {
    attrs: {
      "is-loading": _vm.isLoading
    },
    on: {
      "update:isLoading": function($event) {
        _vm.isLoading = $event
      },
      "update:is-loading": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81297352!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/avaliacao/components/Index.vue
// module id = 566
// module chunks = 2